import { validStreedConfig } from "../consts";
import { IFamilyConfig, IOptimizationConfig, IRoadwayConfig } from "../types";

export const showAlert = (data: string | undefined) => {
  if (typeof data === "undefined") {
    console.log("Unknown error");
  } else {
    console.log(`${data}`);
  }
};

export interface IValidateNumber {
  isValid: boolean;
  message?: string;
}

export const numberIsValid = (data: number | undefined, min: number | undefined, max: number | undefined): boolean => {
  if (Number.isNaN(data) || data === undefined || typeof data !== "number") {
    return false;
  }
  if (min !== undefined && data < min) {
    return false;
  }
  if (max !== undefined && data > max) {
    return false;
  }
  return true;
};
export const roadwayConfigValid = (config: IRoadwayConfig) => {
  return (
    numberIsValid(config.roadWidth, validStreedConfig.roadWidth.min, validStreedConfig.roadWidth.max) &&
    numberIsValid(config.numberOfLanes, validStreedConfig.numberOfLanes.min, validStreedConfig.numberOfLanes.max) &&
    numberIsValid(config.widthOfCentralReservation, validStreedConfig.widthOfCentralReservation.min, validStreedConfig.widthOfCentralReservation.max) &&
    numberIsValid(config.borderAreaLeftWidth, validStreedConfig.borderAreaLeftWidth.min, validStreedConfig.borderAreaLeftWidth.max) &&
    numberIsValid(config.borderAreaLeftKerbDistance, validStreedConfig.borderAreaLeftKerbDistance.min, validStreedConfig.borderAreaLeftKerbDistance.max) &&
    numberIsValid(config.borderAreaRightWidth, validStreedConfig.borderAreaRightWidth.min, validStreedConfig.borderAreaRightWidth.max) &&
    numberIsValid(config.borderAreaRightKerbDistance, validStreedConfig.borderAreaRightKerbDistance.min, validStreedConfig.borderAreaRightKerbDistance.max)
  );
};
export const familyConfigValid = (config: IFamilyConfig) => {
  return config.familyIds.length !== 0;
};

export const optimizationConfigValid = (config: IOptimizationConfig) => {
  const { min, max } = validStreedConfig.maintenanceFactor;
  return numberIsValid(config.maintenanceFactor, min, max);
};

export const resultSelectionConfigValid = (currentStep: number, selectedResulted: string) => {
  return selectedResulted.length !== 0;
};

/**
 * Validates configuration for a given step in the wizard.
 * Returns true if all previous steps have valid configurations.
 */
export interface ConfigValidationParams {
  familyConfig: IFamilyConfig;
  roadwayConfig: IRoadwayConfig;
  optimizationConfig: IOptimizationConfig;
  currentStep: number;
  selectedResult: string;
}

export const isStepConfigValid = (stepId: string, params: ConfigValidationParams): boolean => {
  const { familyConfig, roadwayConfig, optimizationConfig, currentStep, selectedResult } = params;

  switch (stepId) {
    case "Luminaire Selection":
      return familyConfigValid(familyConfig);
    case "Roadway":
      return roadwayConfigValid(roadwayConfig);
    case "Optimization":
      return optimizationConfigValid(optimizationConfig);
    case "Result Selection":
      return resultSelectionConfigValid(currentStep, selectedResult);
    default:
      return true;
  }
};

export const validateNumber = (data: number, min: number, max: number, label?: string): IValidateNumber => {
  if (data < min) {
    return {
      isValid: false,
      message: `${label} cannot be less than than ${min}.`,
    };
  }
  if (data > max) {
    return {
      isValid: false,
      message: `${label} cannot be more than than ${max}.`,
    };
  }
  return {
    isValid: true,
  };
};
